var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      class: _vm.$style.ordersListItem,
      attrs: { xs12: "" },
      on: { click: _vm.emitSavingToCart }
    },
    [
      _c("div", { class: _vm.$style.orderImage }, [
        _vm.orderImage
          ? _c("img", {
              class: _vm.$style.orderIcon,
              attrs: { src: _vm.orderImage }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.orderInfo }, [
        _c("h6", { class: _vm.$style.orderTitle }, [
          _vm._v(_vm._s(_vm.order.title))
        ]),
        _vm._v(" "),
        _c("h6", { class: _vm.$style.orderPrice }, [
          _vm._v(_vm._s(_vm._f("toPrice")(_vm.orderPrice)))
        ]),
        _vm._v(" "),
        _c("p", { class: _vm.$style.orderDate }, [
          _vm._v(_vm._s(_vm.orderDate))
        ])
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.orderRightImage }, [
        _c("svg", {
          directives: [{ name: "svg", rawName: "v-svg" }],
          class: _vm.$style.chevronRight,
          attrs: { symbol: "chevron-left" }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/cart/components/Order.vue?vue&type=template&id=3f1fe580&
// module id = null
// module chunks = 